// extracted by mini-css-extract-plugin
export default {"inlineLoaderWrapper":"_loaders_inlineLoaderWrapper__MBZs4"};